import step1Src from '@images/marketing/HIW-Step1.jpg';
import step2Src from '@images/marketing/HIW-Step2.jpg';
import step3Src from '@images/marketing/HIW-Step3.jpg';
import step4Src from '@images/marketing/HIW-Step4.jpg';
var steps = [
    {
        title: 'Personalized For Them',
        substeps: [
            'Build a profile for your dog',
            'Receive a personalized meal plan',
            'Select a delivery schedule',
        ],
        stepNumber: 1,
        imageData: { src: step1Src, alt: '' },
    },
    {
        title: 'Prepared By Us',
        substeps: [
            'Prepped in our Nashville kitchen',
            'Pre-portioned packs arrive frozen',
            'Get customized feeding instructions',
        ],
        stepNumber: 2,
        imageData: { src: step2Src, alt: '' },
    },
    {
        title: 'Convenient For You',
        substeps: [
            '1st box structured to help transition',
            'Food arrives on a schedule you set',
            'Change or cancel your plan at any time',
        ],
        stepNumber: 3,
        imageData: { src: step3Src, alt: '' },
    },
    {
        title: 'Enriching For Everyone',
        substeps: [
            'Switch up recipes to find their favorite',
            'Speak to our support team anytime',
            'Know you’re delighting your dog',
        ],
        stepNumber: 4,
        imageData: { src: step4Src, alt: '' },
    },
];
export var howItWorksContent = {
    ctaUrl: '/profile',
    steps: steps,
};
